export default __webpack_public_path__ + "i18n/translations/translation-zh.9f796e75.json";